const CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS = {
  inviteNewWorker:
    'Send invitations so new workers can join your agency and appear in Workforce.',
  manageWorkerTypes:
    'Set up the worker roles and pay types your agency uses when assigning people to shifts.',
  manageWorkerFileTypes:
    'Choose which credential and document types workers can upload and your office can track.',
  manageAttributes:
    'Create matching tags for workers and clients so you can filter and assign the right people.',
  workforceNotices:
    'Draft and publish updates and files that workers can read under Care+ Notices.',
  onboardingTemplates:
    'Build checklist templates for new-hire onboarding tasks and required documents.',
  viewShiftConfigs:
    'Review default shift settings your agency uses when creating and scheduling shifts.',
} as const;

export { CLIENT_FACING_WORKFORCE_HEADER_TOOLTIPS };
